import { render, staticRenderFns } from "./TagTimerBanner.vue?vue&type=template&id=7b7434d0&scoped=true&"
import script from "./TagTimerBanner.vue?vue&type=script&lang=js&"
export * from "./TagTimerBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7434d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37545539/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b7434d0')) {
      api.createRecord('7b7434d0', component.options)
    } else {
      api.reload('7b7434d0', component.options)
    }
    module.hot.accept("./TagTimerBanner.vue?vue&type=template&id=7b7434d0&scoped=true&", function () {
      api.rerender('7b7434d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/orange/broadband/internet/showcase/components/TagTimerBanner.vue"
export default component.exports